// extracted by mini-css-extract-plugin
export var formContainer = "_iy-0";
export var message = "_iy-1";